module.exports = __webpack_public_path__ + "home/en-US/images/abc_logo-4522e70aa7c08691769b585997c30f46.png";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/images/abc_logo.png
// module id = vnXA
// module chunks = 0